import { render, staticRenderFns } from "./programs.vue?vue&type=template&id=bea2d02e&lang=pug"
import script from "./programs.vue?vue&type=script&lang=js"
export * from "./programs.vue?vue&type=script&lang=js"
import style0 from "./programs.vue?vue&type=style&index=0&id=bea2d02e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports